export default __webpack_public_path__ + "static/media/Twitter-s-icon_2.a73b0c40.svg";